import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Card from 'react-bootstrap/Card';
import Summary from './summary';
import Editor from './editor';
import useStore from './store-hook';

const SCard = styled(Card)`
  & > .collapse:not(.show) {
    display: none;
  }
`;

export default function Question({ qindex }) {
  const ekey = `qindex-${qindex}`;
  const q = useStore(React.useCallback(state => state.qs[qindex], [qindex]));
  const set = useStore(state => state.set);
  const collapseAll = useAccordionToggle(null);

  const eProps = {
    question: q,
    onCancel: collapseAll,
    onUpdated: d => {
      set(state => {
        state.qs[qindex] = d;
      });
      collapseAll();
    },
  };

  return (
    <SCard>
      <Card.Header>
        <Summary eventKey={ekey} qindex={qindex} />
      </Card.Header>
      <Accordion.Collapse eventKey={ekey}>
        <Card.Body>
          <Editor {...eProps} />
        </Card.Body>
      </Accordion.Collapse>
    </SCard>
  );
}

Question.propTypes = { qindex: PropTypes.number.isRequired };
